import React from 'react'
// components
import Header from 'components/UI/Modal/Header'
import { DrawerModal } from 'components/UI'
// containers
import SubPlanStepperContainer from 'containers/SubPlan'
// constants
import { Modals } from 'constants/modals'
// hooks
import { useModalData } from 'hooks/index'

const PAPER_PROPS = {
  style: {
    overflow: 'hidden'
  }
}

const MODAL_PROPS = {
  disableBackdropClick: true
}

const CreateSubPlanModal: React.FC = () => {
  const {
    hideModal,
    modalData: { isOpen, parentPlan }
  } = useModalData({ modalType: Modals.SUB_PLAN_CREATE_MODAL })

  return (
    <DrawerModal
      width={'unset'}
      isOpen={isOpen}
      hideModal={hideModal}
      ModalProps={MODAL_PROPS}
      PaperProps={PAPER_PROPS}>
      <Header>Create Sub Plan</Header>
      <SubPlanStepperContainer parentPlan={parentPlan} />
    </DrawerModal>
  )
}

export default CreateSubPlanModal
